import { Injectable, HostListener } from '@angular/core';
import { progress } from "@progress/jsdo-core";
import { Subject } from 'rxjs/Subject';
import { AuthenticationService } from './authentication.service';
import { Router } from '@angular/router';
import { fromEvent } from 'rxjs/observable/fromEvent';

@Injectable()
export class KeepAliveService {

    protected intervalSet: boolean = false;
    
    protected userActivity;
    protected userInactive: Subject<any> = new Subject();
    protected keepAliveInterval: NodeJS.Timer;

    constructor(private authenticationService: AuthenticationService, private router: Router) {
        

        this.setTimeout();
        fromEvent(document, 'click')
            .subscribe( () => {
                this.refreshUserState();
            });

        fromEvent(window, 'mousemove')
            .subscribe( () => {
                this.refreshUserState();
            });
            
        this.userInactive.subscribe(() => {
            clearInterval(this.keepAliveInterval);
            sessionStorage.removeItem("SupplierApp.autologin");
            sessionStorage.removeItem("SupplierApp.supplierName");
            this.authenticationService.signOut(); 
        });
        this.setKeepAliveInterval();
    }

    setTimeout() {
        this.userActivity = setTimeout(() => this.userInactive.next(undefined), 3600000);
    }

    refreshUserState() {
        clearTimeout(this.userActivity);
        this.setTimeout();
    }

    public async setKeepAliveInterval() {
        
        if (this.keepAliveInterval)
            return;

        this.keepAliveInterval = setInterval(async () => {

            const jsdo = new progress.data.JSDO("UtilitiesBusinessEntity");
            jsdo.invoke("KeepAlive");
        },60000); 
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/core/auth/keep-alive.service.ts